import React, { useState, useEffect } from 'react'
import { PublicIndexContext } from './PublicIndexContext'
import Login from '../services/api/Login'
import ExternalForm from '../services/api/ExternalForm'
import SiteState from '../services/api/SiteState'
import PowerOfAttorney from '../services/api/PowerOfAttorney'
import OrganizationSetting from '../services/api/OrganizationSetting'
import Error from '../components/Error'
import PropTypes from 'prop-types'
import queryString from 'query-string'

const TOKEN_REFRESH_INTERVAL = 300000 // 5min

const PublicIndexProvider = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false)
  const [loading, setIsLoading] = useState(false)
  const [isSiteValid, setIsSiteValid] = useState(false)
  const [isAuthenticated, setIsAutheticated] = useState(false)
  const [organizationData, setOrganizationData] = useState(false)
  const [signedPowerOfAttorney, setSignedPowerOfAttorney] = useState(false)
  const [unSignedPowerOfAttorney, setUnSignedPowerOfAttorney] = useState(false)
  const [textToSignWithBankID, setTextToSignWithBankID] = useState(false)
  const [formHeadingTextBeforeSigning, setFormHeadingTextBeforeSigning] = useState(false)
  const [formHeadingTextAfterSigning, setFormHeadingTextAfterSigning] = useState(false)

  const params = queryString.parse(window.location.search)
  const getStyle = (organizationSetting) => {
    return {
      background: {
        background: organizationSetting.backgroundColor
      },
      header: {
        background: organizationSetting.headerBackgroundColor
      },
      button: {
        background: organizationSetting.buttonColor,
        border: organizationSetting.buttonColor
      },
      link: {
        color: organizationSetting.linkColor
      },
      positionOfLogo: organizationSetting.positionOfLogo
    }
  }

  useEffect(() => {
    setIsLoading(true)
    function getOrganizationSetting () {
      const organizationSetting = new OrganizationSetting()
      organizationSetting.get(params.customerId, params.siteId)
        .then(response => {
          if (response.status !== 200) {
            throw new Error(response.status)
          }
          return response.json()
        })
        .then(data => {
          if (data.isDigitalRegistrationSigningActive === '1') {
            setTextToSignWithBankID(data.textToSignWithBankID)
            setFormHeadingTextBeforeSigning(data.formHeadingTextBeforeSigning)
            setFormHeadingTextAfterSigning(data.formHeadingTextAfterSigning)
          }
        })
        .catch(error => {
          console.log(error)
        })
    };

    function getExternalForm () {
      const externalForm = new ExternalForm()
      externalForm.get(params.customerId)
        .then(response => {
          if (response.status !== 200) {
            throw new Error(response.status)
          }
          return response.json()
        })
        .then(data => {
          setOrganizationData(data)
        })
        .catch(error => {
          console.log(error)
        })
    };

    function getSiteState () {
      const siteState = new SiteState()
      siteState.get(params.siteId)
        .then(response => {
          if (response.status !== 200) {
            throw new Error(response.status)
          }
          return response.json()
        })
        .then(data => {
          if (data.state_id === '28') {
            setIsSiteValid(true)
          }
        })
        .catch(error => {
          console.log(error)
        })
    };

    function getPowerOfAttorney () {
      const poa = new PowerOfAttorney()
      setTimeout(() => {
        poa.get(params.siteId, 4)
          .then(response => {
            if (response.status !== 200) {
              throw new Error(response.status)
            }
            return response.json()
          })
          .then(data => {
            data.forEach(function (item) {
              if (item.statusId === '1' && item.isSigned === '1') {
                setSignedPowerOfAttorney(item)
              } else if (item.statusId === '2' && item.isSigned !== '1') {
                setUnSignedPowerOfAttorney(item)
              }
            })
          })
          .catch(error => {
            console.log(error)
          })
      }, 2000)
    };

    function login () {
      setIsMounted(true)
      const login = new Login()
      login.post(params)
        .then(response => {
          if (response.status !== 200) {
            throw new Error(response.status)
          }
          setIsAutheticated(true)
          return response.json()
        })
        .then(data => {
          localStorage.setItem('token', data.token)
          refreshToken()
          getOrganizationSetting()
          getExternalForm()
          getSiteState()
          getPowerOfAttorney()
        })
        .catch(error => {
          console.log(error)
        })
    }

    function refreshToken () {
      setInterval(function () {
        const login = new Login()
        login.post(params)
          .then(response => {
            if (response.status !== 200) {
              throw new Error(response.status)
            }
            return response.json()
          })
          .then(data => {
            localStorage.setItem('token', data.token)
          })
          .catch(error => {
            console.log(error)
          })
      }, TOKEN_REFRESH_INTERVAL)
    }

    if (!isMounted) {
      login()
    }
  }, [isMounted, params])

  if (
    isAuthenticated &&
        organizationData &&
        textToSignWithBankID &&
        formHeadingTextBeforeSigning &&
        formHeadingTextAfterSigning &&
        isMounted &&
        (signedPowerOfAttorney || (isSiteValid && unSignedPowerOfAttorney))
  ) {
    return (
      <PublicIndexContext.Provider
        value={{
          customerId: params.customerId,
          siteId: params.siteId,
          isAuthenticated,
          organizationData,
          signedPowerOfAttorney,
          unSignedPowerOfAttorney,
          textToSignWithBankID,
          formHeadingTextBeforeSigning,
          formHeadingTextAfterSigning,
          style: getStyle(organizationData)
        }}
      >
        {children}
      </PublicIndexContext.Provider>
    )
  }

  if (loading) {
    return null
  } else {
    return <Error />
  }
}

PublicIndexProvider.propTypes = {
  children: PropTypes.node.isRequired
}

const PublicIndexConsumer = PublicIndexContext.Consumer
export { PublicIndexProvider, PublicIndexConsumer }
